module.exports = __webpack_public_path__ + "img/st.ea8969a4.png";